import ProjectCard, { type CardMeta } from '../ProjectCard/ProjectCard';
import type { Project } from '../../../data/projects';
import styles from './ProjectGrid.module.css';

interface ProjectGridProps {
    projects: Project[];
    meta?: CardMeta;
}

export default function ProjectGrid({ projects, meta = 'links' }: ProjectGridProps) {
    return (
        <ul className={styles.grid}>
            {projects.map((project, index) => (
                <li key={project.slug} className={styles.item}>
                    <ProjectCard project={project} format={index === 0 ? 'wide' : 'card'} meta={meta} />
                </li>
            ))}
        </ul>
    );
}
